import { useEffect } from "react";
import "./App.css";
import { Shell } from "./components/Shell/Shell";
import { registerApps } from "./utils/appRegistry";
import { WebOSApp } from "./types/webos";
import { App as AnimalSoundsApp } from "./components/apps/AnimalSounds/App";
import { App as DrawApp } from "./components/apps/Draw/App";
import { App as MusicPlayerApp } from "./components/apps/MusicPlayer/App";
import { App as AnimalPadApp } from "./components/apps/AnimalPad/App";
import { App as ColorPadApp } from "./components/apps/ColorPad/App";

import initReactFastclick from "react-fastclick";
initReactFastclick();

// Register demo apps
const demoApps: WebOSApp[] = [
  {
    id: "animal-sounds",
    name: "Les animaux",
    icon: "🐈",
    description: "Les animaux et leurs sons",
    component: AnimalSoundsApp,
    category: "entertainment",
    version: "1.0.0",
    author: "WebOS Team",
  },
  {
    id: "draw",
    name: "Dessiner",
    icon: "✎",
    description: "Dessiner",
    component: DrawApp,
    category: "entertainment",
    version: "1.0.0",
    author: "WebOS Team",
  },
  {
    id: "animal-pad",
    name: "Animal Pad",
    icon: "🐾",
    description: "Pad MIDI pour les animaux",
    component: AnimalPadApp,
    category: "entertainment",
    version: "1.0.0",
    author: "WebOS Team",
  },
  {
    id: "color-pad",
    name: "Les Couleurs",
    icon: "🎨",
    description: "Découvre les couleurs",
    component: ColorPadApp,
    category: "entertainment",
    version: "1.0.0",
    author: "WebOS Team",
  },
  {
    id: "music-player",
    name: "Music Player",
    icon: "🎵",
    description: "Simple MP3 music player with oscilloscope visualization",
    component: MusicPlayerApp,
    category: "entertainment",
    version: "1.0.0",
    author: "WebOS Team",
  },
];

export function App() {
  useEffect(() => {
    // Register demo apps on app startup
    registerApps(demoApps);
  }, []);

  return <Shell />;
}
